import styled from "styled-components";

import { SmallButton } from "../../../../components";
import { TableStyled } from "../../../../components/Table/styled";

export const NewButton = styled(SmallButton)`
  padding: 0 32px;
`;

export const StoresTableWrapper = styled.div`
  ${TableStyled} {
    th:last-child,
    td:last-child {
      padding-right: 0;
    }

    th,
    td {
      padding-left: 16px;
    }

    th:first-child,
    td:first-child {
      padding-left: 24px;

      div {
        margin-left: unset;
      }
    }
  }
`;
